var AccessoryType;
(function(AccessoryType) {
    AccessoryType["AUDIO_BATTERY"] = "AUDIO_BATTERY";
    AccessoryType["AUDIO_CLEANING"] = "AUDIO_CLEANING";
    AccessoryType["AUDIO_EARPLUG"] = "AUDIO_EARPLUG";
    AccessoryType["AUDIO_HEADSET"] = "AUDIO_HEADSET";
    AccessoryType["BLUEFILTER_MASK_CLIPS"] = "BLUEFILTER_MASK_CLIPS";
    AccessoryType["CASES"] = "CASES";
    AccessoryType["CHARMS"] = "CHARMS";
    AccessoryType["CLEANING_CLOTH"] = "CLEANING_CLOTH";
    AccessoryType["CLEANING_LIQUID"] = "CLEANING_LIQUID";
    AccessoryType["CORDS"] = "CORDS";
    AccessoryType["MAGNETS"] = "MAGNETS";
    AccessoryType["MISCELLANEOUS"] = "MISCELLANEOUS";
    AccessoryType["NIGHTDRIVE_MASK_CLIPS"] = "NIGHTDRIVE_MASK_CLIPS";
    AccessoryType["SKI_GOGGLES"] = "SKI_GOGGLES";
    AccessoryType["SLIDERS"] = "SLIDERS";
    AccessoryType["SUNCOVER"] = "SUNCOVER";
    AccessoryType["SUN_MASK_CLIPS"] = "SUN_MASK_CLIPS";
    AccessoryType["SWIMMING_GOGGLES"] = "SWIMMING_GOGGLES";
})(AccessoryType || (AccessoryType = {}));
var AccountOrigination;
(function(AccountOrigination) {
    AccountOrigination[/** Account was created in store */ "IN_STORE"] = "IN_STORE";
    AccountOrigination[/** Account was created online */ "ONLINE"] = "ONLINE";
})(AccountOrigination || (AccountOrigination = {}));
var AccountReason;
(function(AccountReason) {
    AccountReason[/** An account created for scheduling an appointment */ "APPOINTMENT"] = "APPOINTMENT";
    AccountReason[/** An account created for placing an order */ "ORDER"] = "ORDER";
    AccountReason[/** An account created for signing up */ "SIGN_UP"] = "SIGN_UP";
    AccountReason[/** An account created for a subscription */ "SUBSCRIPTION"] = "SUBSCRIPTION";
})(AccountReason || (AccountReason = {}));
var AccountVerificationMethod;
(function(AccountVerificationMethod) {
    AccountVerificationMethod[/** Verifying an account using a date of birth */ "DATE_OF_BIRTH"] = "DATE_OF_BIRTH";
    AccountVerificationMethod[/** No verification needed */ "NONE"] = "NONE";
})(AccountVerificationMethod || (AccountVerificationMethod = {}));
var AppointmentCommunicationChannel;
(function(AppointmentCommunicationChannel) {
    AppointmentCommunicationChannel["EMAIL"] = "EMAIL";
    AppointmentCommunicationChannel["SMS"] = "SMS";
})(AppointmentCommunicationChannel || (AppointmentCommunicationChannel = {}));
var AppointmentTypeAgeGroup;
(function(AppointmentTypeAgeGroup) {
    AppointmentTypeAgeGroup["ADULT"] = "ADULT";
    AppointmentTypeAgeGroup["CHILD"] = "CHILD";
    AppointmentTypeAgeGroup["SENIOR"] = "SENIOR";
})(AppointmentTypeAgeGroup || (AppointmentTypeAgeGroup = {}));
var BillingFrequency;
(function(BillingFrequency) {
    BillingFrequency["MONTHLY"] = "MONTHLY";
    BillingFrequency["QUARTERLY"] = "QUARTERLY";
})(BillingFrequency || (BillingFrequency = {}));
var BundleLineItemProductType;
(function(BundleLineItemProductType) {
    BundleLineItemProductType["LENS"] = "LENS";
    BundleLineItemProductType["SOLUTION"] = "SOLUTION";
})(BundleLineItemProductType || (BundleLineItemProductType = {}));
var BundleLineItemType;
(function(BundleLineItemType) {
    BundleLineItemType["COMPOSITE"] = "COMPOSITE";
    BundleLineItemType["CONTACT_LENSES_BENELUX"] = "CONTACT_LENSES_BENELUX";
    BundleLineItemType["CONTACT_LENSES_SUBSCRIPTION"] = "CONTACT_LENSES_SUBSCRIPTION";
    BundleLineItemType["NON_PRESCRIPTION_BUNDLE"] = "NON_PRESCRIPTION_BUNDLE";
    BundleLineItemType["PRESCRIPTION_GLASSES"] = "PRESCRIPTION_GLASSES";
})(BundleLineItemType || (BundleLineItemType = {}));
var CacheControlScope;
(function(CacheControlScope) {
    CacheControlScope["PRIVATE"] = "PRIVATE";
    CacheControlScope["PUBLIC"] = "PUBLIC";
})(CacheControlScope || (CacheControlScope = {}));
var CartCustomerType;
(function(CartCustomerType) {
    CartCustomerType["B2B"] = "B2B";
    CartCustomerType["B2C"] = "B2C";
})(CartCustomerType || (CartCustomerType = {}));
var CartDiscountType;
(function(CartDiscountType) {
    CartDiscountType["AMOUNT"] = "AMOUNT";
    CartDiscountType["PERCENT"] = "PERCENT";
})(CartDiscountType || (CartDiscountType = {}));
var CartState;
(function(CartState) {
    CartState["Active"] = "Active";
    CartState["Merged"] = "Merged";
    CartState["Ordered"] = "Ordered";
})(CartState || (CartState = {}));
var ChannelAvailability;
(function(ChannelAvailability) {
    ChannelAvailability["IN_STORE_ONLY"] = "IN_STORE_ONLY";
    ChannelAvailability["ONLINE"] = "ONLINE";
})(ChannelAvailability || (ChannelAvailability = {}));
var ChannelType;
(function(ChannelType) {
    ChannelType["ONLINE"] = "ONLINE";
    ChannelType["STORE"] = "STORE";
})(ChannelType || (ChannelType = {}));
var CheckoutCustomerType;
(function(CheckoutCustomerType) {
    CheckoutCustomerType["B2B"] = "B2B";
    CheckoutCustomerType["B2C"] = "B2C";
})(CheckoutCustomerType || (CheckoutCustomerType = {}));
var CheckoutState;
(function(CheckoutState) {
    CheckoutState["Finalized"] = "Finalized";
    CheckoutState["InProgress"] = "InProgress";
    CheckoutState["ReadyToOrder"] = "ReadyToOrder";
})(CheckoutState || (CheckoutState = {}));
var ColorType;
(function(ColorType) {
    ColorType["SINGLE_GRADIENT"] = "SINGLE_GRADIENT";
    ColorType["SOLID"] = "SOLID";
})(ColorType || (ColorType = {}));
var CommunicationChannel;
(function(CommunicationChannel) {
    CommunicationChannel["EMAIL"] = "EMAIL";
    CommunicationChannel["SMS"] = "SMS";
})(CommunicationChannel || (CommunicationChannel = {}));
var CompleteSocialLoginFailureType;
(function(CompleteSocialLoginFailureType) {
    CompleteSocialLoginFailureType[/** Something went wrong with the authentication */ "AUTHENTICATION"] = "AUTHENTICATION";
    CompleteSocialLoginFailureType[/** The feature is disabled */ "FEATURE_DISABLED"] = "FEATURE_DISABLED";
    CompleteSocialLoginFailureType[/** An unknown failure occurred */ "UNKNOWN"] = "UNKNOWN";
})(CompleteSocialLoginFailureType || (CompleteSocialLoginFailureType = {}));
var CreateAccountTargetAction;
(function(CreateAccountTargetAction) {
    CreateAccountTargetAction[/** Forgot Password action */ "FORGOT_PASSWORD"] = "FORGOT_PASSWORD";
    CreateAccountTargetAction[/** Sign Up action */ "SIGN_UP"] = "SIGN_UP";
})(CreateAccountTargetAction || (CreateAccountTargetAction = {}));
var CustomerType;
(function(CustomerType) {
    CustomerType[/** Business to business Customer type */ "B2B"] = "B2B";
    CustomerType[/** Business to consumer Customer type */ "B2C"] = "B2C";
})(CustomerType || (CustomerType = {}));
var DayOfWeek;
(function(DayOfWeek) {
    DayOfWeek["FRIDAY"] = "FRIDAY";
    DayOfWeek["MONDAY"] = "MONDAY";
    DayOfWeek["SATURDAY"] = "SATURDAY";
    DayOfWeek["SUNDAY"] = "SUNDAY";
    DayOfWeek["THURSDAY"] = "THURSDAY";
    DayOfWeek["TUESDAY"] = "TUESDAY";
    DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
})(DayOfWeek || (DayOfWeek = {}));
var DeliveryFrequency;
(function(DeliveryFrequency) {
    DeliveryFrequency["MONTHLY"] = "MONTHLY";
    DeliveryFrequency["QUARTERLY"] = "QUARTERLY";
})(DeliveryFrequency || (DeliveryFrequency = {}));
var DiscountProductType;
(function(DiscountProductType) {
    DiscountProductType["CART_DISCOUNT"] = "CART_DISCOUNT";
    DiscountProductType["PRODUCT_DISCOUNT"] = "PRODUCT_DISCOUNT";
})(DiscountProductType || (DiscountProductType = {}));
var DiscountType;
(function(DiscountType) {
    DiscountType["ABSOLUTE"] = "ABSOLUTE";
    DiscountType["CartDiscount"] = "CartDiscount";
    DiscountType["ProductDiscount"] = "ProductDiscount";
    DiscountType["RELATIVE"] = "RELATIVE";
})(DiscountType || (DiscountType = {}));
var DiscountValueType;
(function(DiscountValueType) {
    DiscountValueType["ABSOLUTE"] = "ABSOLUTE";
    DiscountValueType["GIFT"] = "GIFT";
    DiscountValueType["RELATIVE"] = "RELATIVE";
})(DiscountValueType || (DiscountValueType = {}));
var Dominance;
(function(Dominance) {
    Dominance["D"] = "D";
    Dominance["N"] = "N";
})(Dominance || (Dominance = {}));
var EyeSide;
(function(EyeSide) {
    EyeSide["BOTH"] = "BOTH";
    EyeSide["LEFT"] = "LEFT";
    EyeSide["RIGHT"] = "RIGHT";
})(EyeSide || (EyeSide = {}));
var FaceShape;
(function(FaceShape) {
    FaceShape["DIAMOND"] = "DIAMOND";
    FaceShape["HEART"] = "HEART";
    FaceShape["OBLONG"] = "OBLONG";
    FaceShape["OVAL"] = "OVAL";
    FaceShape["RECTANGLE"] = "RECTANGLE";
    FaceShape["ROUND"] = "ROUND";
    FaceShape["SQUARE"] = "SQUARE";
    FaceShape["TRIANGLE"] = "TRIANGLE";
})(FaceShape || (FaceShape = {}));
var FilterFieldNames;
(function(FilterFieldNames) {
    FilterFieldNames["group"] = "group";
    FilterFieldNames["slug"] = "slug";
})(FilterFieldNames || (FilterFieldNames = {}));
var FrameShape;
(function(FrameShape) {
    FrameShape["ALMOND"] = "ALMOND";
    FrameShape["AVIATOR"] = "AVIATOR";
    FrameShape["CAT_EYE"] = "CAT_EYE";
    FrameShape["HEXAGONAL"] = "HEXAGONAL";
    FrameShape["IRREGULAR"] = "IRREGULAR";
    FrameShape["MASK"] = "MASK";
    FrameShape["OVAL"] = "OVAL";
    FrameShape["PANTO"] = "PANTO";
    FrameShape["RECATANGLE_SQUARE"] = "RECATANGLE_SQUARE";
    FrameShape["RECTANGLE"] = "RECTANGLE";
    FrameShape["ROUND"] = "ROUND";
    FrameShape["ROUND_OVAL"] = "ROUND_OVAL";
    FrameShape["SQUARE"] = "SQUARE";
    FrameShape["UNDEFINED"] = "UNDEFINED";
})(FrameShape || (FrameShape = {}));
var FrameSize;
(function(FrameSize) {
    FrameSize["EXTRA_SMALL"] = "EXTRA_SMALL";
    FrameSize["LARGE"] = "LARGE";
    FrameSize["MEDIUM"] = "MEDIUM";
    FrameSize["SMALL"] = "SMALL";
})(FrameSize || (FrameSize = {}));
var FrameType;
(function(FrameType) {
    FrameType["CLIPS"] = "CLIPS";
    FrameType["GOOGLE"] = "GOOGLE";
    FrameType["HALF_EYE"] = "HALF_EYE";
    FrameType["MASK"] = "MASK";
    FrameType["SAFETY"] = "SAFETY";
    FrameType["STANDARD"] = "STANDARD";
})(FrameType || (FrameType = {}));
var HttpMethod;
(function(HttpMethod) {
    HttpMethod["GET"] = "GET";
    HttpMethod["POST"] = "POST";
})(HttpMethod || (HttpMethod = {}));
var Intent;
(function(Intent) {
    Intent["AUTHORIZE"] = "AUTHORIZE";
    Intent["CAPTURE"] = "CAPTURE";
})(Intent || (Intent = {}));
var LineItemType;
(function(LineItemType) {
    LineItemType["BUNDLE"] = "BUNDLE";
    LineItemType["CONTACTLENSES"] = "CONTACTLENSES";
    LineItemType["REGULAR"] = "REGULAR";
})(LineItemType || (LineItemType = {}));
var MaterialGroup;
(function(MaterialGroup) {
    MaterialGroup["COMBI"] = "COMBI";
    MaterialGroup["HYBRID"] = "HYBRID";
    MaterialGroup["HYDROGEL"] = "HYDROGEL";
    MaterialGroup["METAL"] = "METAL";
    MaterialGroup["MINERAL"] = "MINERAL";
    MaterialGroup["ORGANIC"] = "ORGANIC";
    MaterialGroup["PLASTIC"] = "PLASTIC";
    MaterialGroup["RIGID_GAS_PERMIABLE"] = "RIGID_GAS_PERMIABLE";
    MaterialGroup["SILICONE_HYDROGEL"] = "SILICONE_HYDROGEL";
    MaterialGroup["UNKNOWN"] = "UNKNOWN";
})(MaterialGroup || (MaterialGroup = {}));
var NewsletterSubscribeStatus;
(function(NewsletterSubscribeStatus) {
    NewsletterSubscribeStatus[/** Newsletter subscription failed, see Failures in NewsletterSubscribeResult */ "FAILURE"] = "FAILURE";
    NewsletterSubscribeStatus[/** Newsletter subscription was successful */ "SUCCESS"] = "SUCCESS";
})(NewsletterSubscribeStatus || (NewsletterSubscribeStatus = {}));
var OfferingAction;
(function(OfferingAction) {
    OfferingAction["ADD_TO_CART"] = "ADD_TO_CART";
    OfferingAction["ADD_TO_CART_UNAVAILABLE"] = "ADD_TO_CART_UNAVAILABLE";
    OfferingAction["OPEN_CONFIGURATOR"] = "OPEN_CONFIGURATOR";
    OfferingAction["OPEN_CONFIGURATOR_UNAVAILABLE"] = "OPEN_CONFIGURATOR_UNAVAILABLE";
})(OfferingAction || (OfferingAction = {}));
var OneyPaymentMethod;
(function(OneyPaymentMethod) {
    OneyPaymentMethod["ONEY_3X"] = "ONEY_3X";
    OneyPaymentMethod["ONEY_4X"] = "ONEY_4X";
})(OneyPaymentMethod || (OneyPaymentMethod = {}));
var OrderDeliveryMethod;
(function(OrderDeliveryMethod) {
    OrderDeliveryMethod["HOME_DELIVERY"] = "HOME_DELIVERY";
    OrderDeliveryMethod["HOME_DELIVERY_EXPRESS"] = "HOME_DELIVERY_EXPRESS";
    OrderDeliveryMethod["NEAREST_PICK_UP"] = "NEAREST_PICK_UP";
    OrderDeliveryMethod["PICK_UP"] = "PICK_UP";
    OrderDeliveryMethod["PICK_UP_POINT"] = "PICK_UP_POINT";
})(OrderDeliveryMethod || (OrderDeliveryMethod = {}));
var OrderPaymentMethod;
(function(OrderPaymentMethod) {
    OrderPaymentMethod["APPLE_PAY"] = "APPLE_PAY";
    OrderPaymentMethod["BANCONTACT_CARD"] = "BANCONTACT_CARD";
    OrderPaymentMethod["BANCONTACT_MOBILE"] = "BANCONTACT_MOBILE";
    OrderPaymentMethod["CARD"] = "CARD";
    OrderPaymentMethod["CASH_ON_DELIVERY"] = "CASH_ON_DELIVERY";
    OrderPaymentMethod["FAKE"] = "FAKE";
    OrderPaymentMethod["GOOGLE_PAY"] = "GOOGLE_PAY";
    OrderPaymentMethod["IDEAL"] = "IDEAL";
    OrderPaymentMethod["KLARNA"] = "KLARNA";
    OrderPaymentMethod["KLARNA_ACCOUNT"] = "KLARNA_ACCOUNT";
    OrderPaymentMethod["MBWAY"] = "MBWAY";
    OrderPaymentMethod["MOBILEPAY"] = "MOBILEPAY";
    OrderPaymentMethod["MULTIBANCO"] = "MULTIBANCO";
    OrderPaymentMethod["ONEY"] = "ONEY";
    OrderPaymentMethod["ONEY_3X"] = "ONEY_3X";
    OrderPaymentMethod["ONEY_4X"] = "ONEY_4X";
    OrderPaymentMethod["PAYPAL"] = "PAYPAL";
    OrderPaymentMethod["SEPA"] = "SEPA";
    OrderPaymentMethod["SWISH"] = "SWISH";
})(OrderPaymentMethod || (OrderPaymentMethod = {}));
var OrderPaymentStatus;
(function(OrderPaymentStatus) {
    OrderPaymentStatus["BALANCE_DUE"] = "BALANCE_DUE";
    OrderPaymentStatus["CREDIT_OWED"] = "CREDIT_OWED";
    OrderPaymentStatus["FAILED"] = "FAILED";
    OrderPaymentStatus["PAID"] = "PAID";
    OrderPaymentStatus["PENDING"] = "PENDING";
})(OrderPaymentStatus || (OrderPaymentStatus = {}));
var OrderShipmentStatus;
(function(OrderShipmentStatus) {
    OrderShipmentStatus["BACK_ORDER"] = "BACK_ORDER";
    OrderShipmentStatus["DELAYED"] = "DELAYED";
    OrderShipmentStatus["PARTIAL"] = "PARTIAL";
    OrderShipmentStatus["PENDING"] = "PENDING";
    OrderShipmentStatus["READY"] = "READY";
    OrderShipmentStatus["SHIPPED"] = "SHIPPED";
})(OrderShipmentStatus || (OrderShipmentStatus = {}));
var OrderStatus;
(function(OrderStatus) {
    OrderStatus["CREATED"] = "CREATED";
    OrderStatus["PAID"] = "PAID";
})(OrderStatus || (OrderStatus = {}));
var PSP;
(function(PSP) {
    PSP["ADYEN"] = "ADYEN";
    PSP["CASH_ON_DELIVERY"] = "CASH_ON_DELIVERY";
    PSP["FAKE"] = "FAKE";
    PSP["PAYPAL"] = "PAYPAL";
})(PSP || (PSP = {}));
var PaymentMethod;
(function(PaymentMethod) {
    PaymentMethod["APPLE_PAY"] = "APPLE_PAY";
    PaymentMethod["BANCONTACT_CARD"] = "BANCONTACT_CARD";
    PaymentMethod["BANCONTACT_MOBILE"] = "BANCONTACT_MOBILE";
    PaymentMethod["CASH_ON_DELIVERY"] = "CASH_ON_DELIVERY";
    PaymentMethod["CREDITCARD"] = "CREDITCARD";
    PaymentMethod["FAKE"] = "FAKE";
    PaymentMethod["GOOGLE_PAY"] = "GOOGLE_PAY";
    PaymentMethod["IDEAL"] = "IDEAL";
    PaymentMethod["KLARNA"] = "KLARNA";
    PaymentMethod["KLARNA_ACCOUNT"] = "KLARNA_ACCOUNT";
    PaymentMethod["MBWAY"] = "MBWAY";
    PaymentMethod["MOBILE_PAY"] = "MOBILE_PAY";
    PaymentMethod["MULTIBANCO"] = "MULTIBANCO";
    PaymentMethod["ONEY"] = "ONEY";
    PaymentMethod["PAYPAL"] = "PAYPAL";
    PaymentMethod["SEPA_DIRECT_DEBIT"] = "SEPA_DIRECT_DEBIT";
    PaymentMethod["SWISH"] = "SWISH";
})(PaymentMethod || (PaymentMethod = {}));
var PaymentState;
(function(PaymentState) {
    PaymentState["Cancelled"] = "Cancelled";
    PaymentState["Failed"] = "Failed";
    PaymentState["Paid"] = "Paid";
    PaymentState["Pending"] = "Pending";
})(PaymentState || (PaymentState = {}));
var PickupPointType;
(function(PickupPointType) {
    PickupPointType["FOREIGN_POST_OFFICE"] = "FOREIGN_POST_OFFICE";
    PickupPointType["LOCAL_LOCKERS"] = "LOCAL_LOCKERS";
    PickupPointType["LOCAL_POST_AGENCY"] = "LOCAL_POST_AGENCY";
    PickupPointType["LOCAL_POST_DISTRIBUTIION_CENTRE"] = "LOCAL_POST_DISTRIBUTIION_CENTRE";
    PickupPointType["LOCAL_POST_OFFICE"] = "LOCAL_POST_OFFICE";
    PickupPointType["LOCAL_SHOPS"] = "LOCAL_SHOPS";
    PickupPointType["LOCAL_SHOPS_ABROAD"] = "LOCAL_SHOPS_ABROAD";
})(PickupPointType || (PickupPointType = {}));
var PrescriptionGlassesOptionType;
(function(PrescriptionGlassesOptionType) {
    PrescriptionGlassesOptionType["BLUE_LIGHT_FILTER"] = "BLUE_LIGHT_FILTER";
    PrescriptionGlassesOptionType["MIRRORING"] = "MIRRORING";
    PrescriptionGlassesOptionType["PHOTOCHROMIC"] = "PHOTOCHROMIC";
    PrescriptionGlassesOptionType["POLARISING"] = "POLARISING";
})(PrescriptionGlassesOptionType || (PrescriptionGlassesOptionType = {}));
var PrescriptionGlassesPackageOptionsTransitionType;
(function(PrescriptionGlassesPackageOptionsTransitionType) {
    PrescriptionGlassesPackageOptionsTransitionType["SIGNATURE"] = "SIGNATURE";
    PrescriptionGlassesPackageOptionsTransitionType["XTRACTIVE"] = "XTRACTIVE";
})(PrescriptionGlassesPackageOptionsTransitionType || (PrescriptionGlassesPackageOptionsTransitionType = {}));
var PrescriptionType;
(function(PrescriptionType) {
    PrescriptionType["CONTACT_LENS_PRESCRIPTION"] = "CONTACT_LENS_PRESCRIPTION";
    PrescriptionType["HEARING_AID_PRESCRIPTION"] = "HEARING_AID_PRESCRIPTION";
    PrescriptionType["PRESCRIPTION_GLASSES_PRESCRIPTION"] = "PRESCRIPTION_GLASSES_PRESCRIPTION";
})(PrescriptionType || (PrescriptionType = {}));
var PrescriptionValuesFromDocumentResultCode;
(function(PrescriptionValuesFromDocumentResultCode) {
    PrescriptionValuesFromDocumentResultCode["ERROR"] = "ERROR";
    PrescriptionValuesFromDocumentResultCode["OCR_UNAVAILABLE"] = "OCR_UNAVAILABLE";
    PrescriptionValuesFromDocumentResultCode["SUCCESS"] = "SUCCESS";
})(PrescriptionValuesFromDocumentResultCode || (PrescriptionValuesFromDocumentResultCode = {}));
var PromotionChannel;
(function(PromotionChannel) {
    PromotionChannel["POS"] = "POS";
    PromotionChannel["WEB"] = "WEB";
})(PromotionChannel || (PromotionChannel = {}));
var RecommendationDiscountType;
(function(RecommendationDiscountType) {
    RecommendationDiscountType["CART_DISCOUNT"] = "CART_DISCOUNT";
    RecommendationDiscountType["PRODUCT_DISCOUNT"] = "PRODUCT_DISCOUNT";
})(RecommendationDiscountType || (RecommendationDiscountType = {}));
var RedeemResult;
(function(RedeemResult) {
    RedeemResult["FAILED"] = "FAILED";
    RedeemResult["SUCCESS"] = "SUCCESS";
})(RedeemResult || (RedeemResult = {}));
var ReplacementFrequency;
(function(ReplacementFrequency) {
    ReplacementFrequency["BI_WEEKLY"] = "BI_WEEKLY";
    ReplacementFrequency["DAILY"] = "DAILY";
    ReplacementFrequency["MONTHLY"] = "MONTHLY";
})(ReplacementFrequency || (ReplacementFrequency = {}));
var RequestSocialLoginMergeFailureType;
(function(RequestSocialLoginMergeFailureType) {
    RequestSocialLoginMergeFailureType[/** Something went wrong with the authentication */ "AUTHENTICATION"] = "AUTHENTICATION";
    RequestSocialLoginMergeFailureType[/** The feature is disabled */ "FEATURE_DISABLED"] = "FEATURE_DISABLED";
    RequestSocialLoginMergeFailureType[/** An unknown failure occurred */ "UNKNOWN"] = "UNKNOWN";
})(RequestSocialLoginMergeFailureType || (RequestSocialLoginMergeFailureType = {}));
var ReservationState;
(function(ReservationState) {
    ReservationState["CANCELLED"] = "CANCELLED";
    ReservationState["CLOSED"] = "CLOSED";
    ReservationState["CLOSED_NO_SHOW"] = "CLOSED_NO_SHOW";
    ReservationState["CLOSED_SHOW"] = "CLOSED_SHOW";
    ReservationState["CONFIRMED"] = "CONFIRMED";
    ReservationState["REJECTED_AUTOMATICALLY"] = "REJECTED_AUTOMATICALLY";
    ReservationState["REJECTED_BY_STORE"] = "REJECTED_BY_STORE";
    ReservationState["REQUESTED"] = "REQUESTED";
    ReservationState["UNKNOWN"] = "UNKNOWN";
})(ReservationState || (ReservationState = {}));
var ResultType;
(function(ResultType) {
    ResultType["AUTHORISED"] = "AUTHORISED";
    ResultType["CANCELLED"] = "CANCELLED";
    ResultType["ERROR"] = "ERROR";
    ResultType["PENDING"] = "PENDING";
    ResultType["QRCODE"] = "QRCODE";
    ResultType["RECEIVED"] = "RECEIVED";
    ResultType["REDIRECT"] = "REDIRECT";
    ResultType["REFUSED"] = "REFUSED";
    ResultType["VOUCHER"] = "VOUCHER";
})(ResultType || (ResultType = {}));
var RimType;
(function(RimType) {
    RimType["FULL_RIM"] = "FULL_RIM";
    RimType["HALF_RIM"] = "HALF_RIM";
    RimType["RIMLESS"] = "RIMLESS";
    RimType["UNKNOWN"] = "UNKNOWN";
})(RimType || (RimType = {}));
var SanitizationAction;
(function(SanitizationAction) {
    SanitizationAction["KeepExisting"] = "KeepExisting";
    SanitizationAction["Replace"] = "Replace";
})(SanitizationAction || (SanitizationAction = {}));
var ServicesNotAvailable;
(function(ServicesNotAvailable) {
    ServicesNotAvailable["APPOINTMENTS"] = "APPOINTMENTS";
    ServicesNotAvailable["CLICK_AND_RESERVE"] = "CLICK_AND_RESERVE";
    ServicesNotAvailable["EVENING_APPOINTMENTS"] = "EVENING_APPOINTMENTS";
    ServicesNotAvailable["OPTOMETRY"] = "OPTOMETRY";
    ServicesNotAvailable["PICK_UP_IN_STORE"] = "PICK_UP_IN_STORE";
})(ServicesNotAvailable || (ServicesNotAvailable = {}));
var ShoppinglistType;
(function(ShoppinglistType) {
    ShoppinglistType[/** of type Wishlist */ "WISHLIST"] = "WISHLIST";
})(ShoppinglistType || (ShoppinglistType = {}));
var SourceChannel;
(function(SourceChannel) {
    SourceChannel[/** Account was created through Customer 360 */ "C360"] = "C360";
    SourceChannel[/** Account was created through ecommerce */ "ECOMMERCE"] = "ECOMMERCE";
})(SourceChannel || (SourceChannel = {}));
var Status;
(function(Status) {
    Status["OFFLINE"] = "OFFLINE";
    Status["ONLINE"] = "ONLINE";
})(Status || (Status = {}));
var StockIndicator;
(function(StockIndicator) {
    StockIndicator["IN_STOCK"] = "IN_STOCK";
    StockIndicator["LOW_STOCK"] = "LOW_STOCK";
    StockIndicator["OUT_OF_STOCK"] = "OUT_OF_STOCK";
    StockIndicator["UNKNOWN"] = "UNKNOWN";
})(StockIndicator || (StockIndicator = {}));
var StoreAppointmentDurationUnit;
(function(StoreAppointmentDurationUnit) {
    StoreAppointmentDurationUnit["MINUTES"] = "MINUTES";
})(StoreAppointmentDurationUnit || (StoreAppointmentDurationUnit = {}));
var StoreOfferType;
(function(StoreOfferType) {
    StoreOfferType["OFFER"] = "OFFER";
})(StoreOfferType || (StoreOfferType = {}));
var SubscriptionEyeSide;
(function(SubscriptionEyeSide) {
    SubscriptionEyeSide["LEFT"] = "LEFT";
    SubscriptionEyeSide["RIGHT"] = "RIGHT";
})(SubscriptionEyeSide || (SubscriptionEyeSide = {}));
var TargetGender;
(function(TargetGender) {
    TargetGender["FEMALE"] = "FEMALE";
    TargetGender["MALE"] = "MALE";
    TargetGender["UNDEFINED"] = "UNDEFINED";
    TargetGender["UNISEX"] = "UNISEX";
})(TargetGender || (TargetGender = {}));
var UIElementType;
(function(UIElementType) {
    UIElementType[/** A checkbox UI element */ "CHECKBOX"] = "CHECKBOX";
})(UIElementType || (UIElementType = {}));
var UIType;
(function(UIType) {
    UIType[/** A checkbox UI element */ "CHECKBOX"] = "CHECKBOX";
})(UIType || (UIType = {}));
var ValidationCode;
(function(ValidationCode) {
    ValidationCode["CONTAINS_MUTUALLY_EXCLUSIVE_PRODUCT_TYPES"] = "CONTAINS_MUTUALLY_EXCLUSIVE_PRODUCT_TYPES";
    ValidationCode["HAS_VALID_OPTICIAN_DETAILS"] = "HAS_VALID_OPTICIAN_DETAILS";
    ValidationCode["HAS_VALID_PRESCRIPTION_DATA_RANGES"] = "HAS_VALID_PRESCRIPTION_DATA_RANGES";
    ValidationCode["IS_IN_STOCK"] = "IS_IN_STOCK";
    ValidationCode["IS_VALID_AMOUNT_OF_MASTER_VARIANTS"] = "IS_VALID_AMOUNT_OF_MASTER_VARIANTS";
    ValidationCode["IS_VALID_CART_BY_PRESCRIPTION"] = "IS_VALID_CART_BY_PRESCRIPTION";
    ValidationCode["IS_VALID_EXPIRY_DATE"] = "IS_VALID_EXPIRY_DATE";
    ValidationCode["IS_VALID_QUANTITY"] = "IS_VALID_QUANTITY";
    ValidationCode["MAX_QUANTITY_PER_LINE_ITEM_TYPE"] = "MAX_QUANTITY_PER_LINE_ITEM_TYPE";
    ValidationCode["MAX_QUANTITY_PER_PRODUCT_TYPE"] = "MAX_QUANTITY_PER_PRODUCT_TYPE";
    ValidationCode["MAX_VARIANTS_PER_PRODUCT_TYPE"] = "MAX_VARIANTS_PER_PRODUCT_TYPE";
    ValidationCode["ONE_LENS_TYPE_PER_EYE"] = "ONE_LENS_TYPE_PER_EYE";
    ValidationCode["PRODUCTS_ARE_NOT_EXCLUDED_FROM_CHECKOUT"] = "PRODUCTS_ARE_NOT_EXCLUDED_FROM_CHECKOUT";
    ValidationCode["PRODUCTS_ARE_PUBLISHED"] = "PRODUCTS_ARE_PUBLISHED";
    ValidationCode["REQUIRED_PRODUCT_TYPES_ARE_IN_BUNDLE"] = "REQUIRED_PRODUCT_TYPES_ARE_IN_BUNDLE";
    ValidationCode["VALID_CART_BY_PRODUCT_TYPES"] = "VALID_CART_BY_PRODUCT_TYPES";
    ValidationCode["VALID_RELATIONS_BUNDLE_PRODUCTS"] = "VALID_RELATIONS_BUNDLE_PRODUCTS";
})(ValidationCode || (ValidationCode = {}));
var VoucherDiscountType;
(function(VoucherDiscountType) {
    VoucherDiscountType["AMOUNT"] = "AMOUNT";
    VoucherDiscountType["FIXED"] = "FIXED";
    VoucherDiscountType["PERCENT"] = "PERCENT";
    VoucherDiscountType["UNIT"] = "UNIT";
})(VoucherDiscountType || (VoucherDiscountType = {}));
var VoucherEffectType;
(function(VoucherEffectType) {
    VoucherEffectType["ADD_MANY_ITEMS"] = "ADD_MANY_ITEMS";
    VoucherEffectType["ADD_MISSING_ITEMS"] = "ADD_MISSING_ITEMS";
    VoucherEffectType["ADD_NEW_ITEMS"] = "ADD_NEW_ITEMS";
    VoucherEffectType["APPLY_TO_ITEMS"] = "APPLY_TO_ITEMS";
    VoucherEffectType["APPLY_TO_ITEMS_PROPORTIONALLY"] = "APPLY_TO_ITEMS_PROPORTIONALLY";
    VoucherEffectType["APPLY_TO_ITEMS_PROPORTIONALLY_BY_QUANTITY"] = "APPLY_TO_ITEMS_PROPORTIONALLY_BY_QUANTITY";
    VoucherEffectType["APPLY_TO_ORDER"] = "APPLY_TO_ORDER";
})(VoucherEffectType || (VoucherEffectType = {}));
var VoucherState;
(function(VoucherState) {
    VoucherState["ApplicationStoppedByPreviousDiscount"] = "ApplicationStoppedByPreviousDiscount";
    VoucherState["DoesNotMatchCart"] = "DoesNotMatchCart";
    VoucherState["MatchesCart"] = "MatchesCart";
    VoucherState["MaxApplicationReached"] = "MaxApplicationReached";
    VoucherState["NotActive"] = "NotActive";
    VoucherState["NotValid"] = "NotValid";
})(VoucherState || (VoucherState = {}));

export { AccessoryType, AccountOrigination, AccountReason, AccountVerificationMethod, AppointmentCommunicationChannel, AppointmentTypeAgeGroup, BillingFrequency, BundleLineItemProductType, BundleLineItemType, CacheControlScope, CartCustomerType, CartDiscountType, CartState, ChannelAvailability, ChannelType, CheckoutCustomerType, CheckoutState, ColorType, CommunicationChannel, CompleteSocialLoginFailureType, CreateAccountTargetAction, CustomerType, DayOfWeek, DeliveryFrequency, DiscountProductType, DiscountType, DiscountValueType, Dominance, EyeSide, FaceShape, FilterFieldNames, FrameShape, FrameSize, FrameType, HttpMethod, Intent, LineItemType, MaterialGroup, NewsletterSubscribeStatus, OfferingAction, OneyPaymentMethod, OrderDeliveryMethod, OrderPaymentMethod, OrderPaymentStatus, OrderShipmentStatus, OrderStatus, PSP, PaymentMethod, PaymentState, PickupPointType, PrescriptionGlassesOptionType, PrescriptionGlassesPackageOptionsTransitionType, PrescriptionType, PrescriptionValuesFromDocumentResultCode, PromotionChannel, RecommendationDiscountType, RedeemResult, ReplacementFrequency, RequestSocialLoginMergeFailureType, ReservationState, ResultType, RimType, SanitizationAction, ServicesNotAvailable, ShoppinglistType, SourceChannel, Status, StockIndicator, StoreAppointmentDurationUnit, StoreOfferType, SubscriptionEyeSide, TargetGender, UIElementType, UIType, ValidationCode, VoucherDiscountType, VoucherEffectType, VoucherState };
//# sourceMappingURL=generated-types.js.map
